import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { PDPScrollingGalleryElements } from "./PDPScrollingGalleryElements";
import { PdpGalleryWithLightboxProps } from "../PDP_Lightbox/use-pdp-gallery-with-lightbox";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { galleryWrapperStyles } from "../PDP_SingleImageCarousel/styles";
import cn from "classnames";
import React from "react";
import { usePdpTranslations } from "../PdpTranslationsContext";
import { T } from "../../../components/T";

export const PDPScrollingGallery: ReactTFC<{
  galleryWithLightbox: PdpGalleryWithLightboxProps;
}> = ({ galleryWithLightbox }) => {
  const t = usePdpTranslations();
  const lifestyleAssetParagraph = t("lifestyleAssetParagraph");

  if (!galleryWithLightbox || galleryWithLightbox.galleryConfig.scrollingGalleryElements.length === 0) {
    return null;
  }

  return (
    <>
      <div
        css={css`
          display: none;

          ${CSS_MQ.atLeastMd} {
            display: block;
          }
        `}
      >
        <Spacer size={"md"} />

        <div>
          <div
            css={galleryWrapperStyles}
            className={cn({ "additional-margin": !galleryWithLightbox.galleryConfig.hasLifestyleAsset })}
          >
            <PDPScrollingGalleryElements galleryWithLightbox={galleryWithLightbox} />
          </div>

          {galleryWithLightbox.galleryConfig.hasLifestyleAsset && (
            <p css={paragraphStyles}>
              <T>{lifestyleAssetParagraph}</T>
            </p>
          )}
        </div>
      </div>
    </>
  );
};

const paragraphStyles = [
  FONTS.SwarovskiFutura300,
  fontSize.x2s,
  css`
    margin-top: 20px;
    ${CSS_MQ.atLeastMd} {
      margin-top: 30px;
    }

    margin-bottom: 0;
  `,
];
